module.exports = __webpack_public_path__ + "static/media/HomeRoll_Walls_MudBrkWall.8c648e9a.jpg";